"use client";

import { ScanSearch, ShieldCheck, Scale, UserCog } from "lucide-react";
import ServicePage from "@/components/ServicePage";
import MetadataUpdater from "@/components/MetadataUpdater";
import { serviceSummary } from "@/data/knowledge/services";

export default function ConsultingPage() {
  return (
    <>
    <MetadataUpdater
      titleKey="meta.solutions.consulting.title"
      description={serviceSummary("consulting")}
    />
    <ServicePage
      labelKey="service.consulting.label"
      titleKey="service.consulting.title"
      descriptionKey="service.consulting.description"
      /*
        The regulation block names three laws, so the page states its own limit
        where a reader of that block meets it — under the hero, not in a footer.
      */
      noticeKey="service.consulting.notice"
      benefits={[
        {
          icon: ScanSearch,
          titleKey: "service.consulting.benefit1.title",
          descKey: "service.consulting.benefit1.desc",
        },
        {
          icon: ShieldCheck,
          titleKey: "service.consulting.benefit2.title",
          descKey: "service.consulting.benefit2.desc",
        },
        {
          icon: Scale,
          titleKey: "service.consulting.benefit3.title",
          descKey: "service.consulting.benefit3.desc",
        },
        {
          icon: UserCog,
          titleKey: "service.consulting.benefit4.title",
          descKey: "service.consulting.benefit4.desc",
        },
      ]}
      usecaseKeys={[
        "service.consulting.usecase1",
        "service.consulting.usecase2",
        "service.consulting.usecase3",
        "service.consulting.usecase4",
      ]}
      stack={[
        "EU AI Act",
        "Cyber Resilience Act",
        "NIS2",
        "SBOM",
        "CycloneDX",
        "Secure by Design",
        "Vulnerability Handling",
        "Threat Modeling",
        "CI/CD Gates",
        "Audit Logging",
        "Incident Response",
        "Supply Chain",
        "Architecture Review",
        "AI Strategy",
        "Tech Audit",
      ]}
    />
    </>
  );
}
